import React, { PureComponent } from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import MailOutlineSharpIcon from '@material-ui/icons/MailOutlineSharp';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { showPdf } from '../../../../utils/file-util';
import * as api from '../../../../services/api';
import { Snackbar } from '@material-ui/core';
import './CompletedRenewalsActions.css';
import { injectIntl } from 'react-intl';

class CompletedRenewalsActions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onResendEmail(renewalArchive) {
    api.renewals
      .resendCompletedRequest(renewalArchive.renewalId)
      .then(() => {
        this.setState({
          message: this.props.intl.formatMessage({
            id: 'email_success_message'
          })
        });
      })
      .catch((error) =>
        this.setState({
          message: this.props.intl.formatMessage({ id: 'email_error_message' })
        })
      );
  }

  async onDownloadContracts(renewalArchive) {
    try {
      const responses = await api.archivedRenewals.contractsInfo(
        renewalArchive.renewalId
      );
      const promises = responses.data.map((response) =>
        this.downloadPDF(renewalArchive, response.contractType)
      );

      await Promise.all(promises);
    } catch (error) {
      this.setState({
        message: this.props.intl.formatMessage({ id: 'pdf_error_message' })
      });
    }
  }

  async downloadPDF(renewalArchive, agreementType) {
    const response = await api.archivedRenewals.contract(
      renewalArchive.renewalId,
      agreementType
    );

    showPdf(
      response.data,
      `${renewalArchive.deliverToCustomerName
        ? renewalArchive.deliverToCustomerName
        : renewalArchive.customerName}_${agreementType.toLowerCase()}`
    );
  }

  render() {
    return (
      <div className="icon-button-wrapper">
        <Tooltip title="Download Confirmation PDF" placement="top">
          <IconButton
            onClick={() => this.onDownloadContracts(this.props.archivedRenewal)}
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Resend Confirmation Email" placement="top">
          <span>
            <IconButton
              onClick={() => this.onResendEmail(this.props.archivedRenewal)}
              disabled={!this.props.archivedRenewal.customerEmail}
            >
              <MailOutlineSharpIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Snackbar
          open={!!this.state.message}
          onClose={() => {
            this.setState({ message: null });
          }}
          autoHideDuration={5000}
          message={this.state.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </div>
    );
  }
}

export default injectIntl(CompletedRenewalsActions);
